export { Print as default } from './Print';
